// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.fdc487681c2b4e6e32c9.js";
	// return url for filenames based on template
	return "" + {"1167":"666c9b3dd8608fc5fb7c","1393":"c433344146d40d47e068"}[chunkId] + ".js";
};